import { startOfDay } from 'date-fns'

import { useTimeZone } from '../../../../../hooks'
import { transposeToUkTimezoneDate } from '../../../../../utils/date'

import { getNextDateValue } from './useDatePickerTag.utils'

export function useDatePickerTag({ onChange, onChangeRange }) {
  const timezone = useTimeZone()

  function handleChange(value) {
    const nextValue = transposeToUkTimezoneDate(
      value ? startOfDay(value) : null,
      timezone
    )

    onChange?.(nextValue)
  }

  function handleChangeRange([start, end]) {
    const nextStart = getNextDateValue(start, timezone)

    const nextEnd = getNextDateValue(end, timezone)

    onChangeRange?.([nextStart, nextEnd])
  }

  function handleClear() {
    onChange?.(null)
    onChangeRange?.([null, null])
  }

  return {
    handleChange,
    handleChangeRange,
    handleClear,
  }
}
